import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { HISTORICALSEARCH_STATICS } from "./SearchConstants";
import { Checkbox } from "@vds/checkboxes";
import "./search.css";
import { RadioButtonGroup } from "@vds/radio-buttons";
import { DropdownSelect } from "@vds/selects";
import { getLicenseTypeDisplayed } from "../../global/utility/Utils";
import { getActiveLicenseSku, VISION_SKUS_DISPLAYNAME } from "../../global/constants/licensesConstants";

const Search_Where = ({ selectedWhereOptions, setSelectedWhereOptions, setFovListIdsToDisplayGroupBySites }) => {
  const deviceListItem = useSelector((state) => state.deviceReducer);
  const licenses = useSelector((state) => state.licenseReducer.licenses || []); 
  const fovList = deviceListItem.fovList || [];

  
  const FovListWithSearchLicense = fovList?.filter((fov) => fov.licenses !== undefined &&
   fov.licenses.length > 0 &&
    getLicenseTypeDisplayed(getActiveLicenseSku(fov.licenses), licenses) === VISION_SKUS_DISPLAYNAME.VI_FOR_LIC_MON_A &&
   fov?.siteids != undefined);

  const siteReducerSites = useSelector((state) => state.sitesReducer.siteTagList);

  const [siteListWithSearchFovs, setSiteListWithSearchFovs] = useState([]);
  const [floorListWithSelectedSites, setFloorListWithSelectedSites] = useState({});
  const [areaListWithSelectedFloors, setAreaListWithSelectedFloors] = useState({});
  const [selectedSites, setSelectedSites] = useState(selectedWhereOptions?.sites || []);
  const [selectedFloors, setSelectedFloors] = useState(selectedWhereOptions?.floors || []);
  const [selectedAreas, setSelectedAreas] = useState(selectedWhereOptions?.areas || []);
  const [fovListIdsToDisplay, setFovListIdsToDisplay] = useState([]);

  const [companionList, setCompanionList] = useState(deviceListItem.companionDeviceList || []);

  useEffect(() => {
    const tempSiteList = FovListWithSearchLicense.map((fov) => fov?.siteids[0]).flat();
    const uniqueSiteList = [...new Set(tempSiteList)];
    // FovListWithSearchLicense is a new array reference every render, so compare by
    // content (not reference) to avoid re-firing these state updates indefinitely
    // when the derived list hasn't actually changed.
    if (JSON.stringify(siteListWithSearchFovs) !== JSON.stringify(uniqueSiteList)) {
      setSiteListWithSearchFovs(uniqueSiteList);
      if (uniqueSiteList.length > 0) {
        setSelectedSites([uniqueSiteList[0]]);
      }
    }
  }, [FovListWithSearchLicense]);

  useEffect(() => {
    if (selectedSites.length > 0) {
      const siteBasedFloors = siteReducerSites.floors?.filter((floor) => floor?.tagids && selectedSites?.includes(floor.tagids[0]));
      const result = siteBasedFloors.reduce((x, y) => {
        (x[y.tagids?.[0]] = x[y.tagids?.[0]] || []).push(y);
        return x;
      }, {});
      if (selectedFloors.length == 0) {
        setFovListIdsToDisplay(FovListWithSearchLicense.filter((fov) => selectedSites?.includes(fov?.siteids[0])));
      }
      const ccd = deviceListItem.companionDeviceList.filter((f) => f?.siteids?.some((sid) => selectedSites.includes(sid)));
      setCompanionList(ccd);

      setFloorListWithSelectedSites(result);
    }
  }, [selectedSites]);

  useEffect(() => {
    if (selectedFloors.length > 0) {
      const floorBasedAreas = siteReducerSites.areas?.filter((area) => area?.tagids && selectedFloors?.includes(area.tagids[0]));
      const result = floorBasedAreas.reduce((x, y) => {
        (x[y.tagids?.[0]] = x[y.tagids?.[0]] || []).push(y);
        return x;
      }, {});
      setFovListIdsToDisplay(FovListWithSearchLicense.filter((fov) => (fov.tagids || []).filter((item) => selectedFloors.includes(item)).length > 0));
      setAreaListWithSelectedFloors(result);
    } else {
      setAreaListWithSelectedFloors({});
      if (selectedSites.length > 0) {
        setFovListIdsToDisplay(FovListWithSearchLicense.filter((fov) => selectedSites?.includes(fov?.siteids[0])));
      }
    }
  }, [selectedFloors]);

  useEffect(() => {
    if (selectedAreas.length > 0) {
      setFovListIdsToDisplay(FovListWithSearchLicense.filter((fov) => (fov.tagids || []).filter((item) => selectedAreas.includes(item)).length > 0));
    } else {
      if (selectedFloors.length > 0) {
        setFovListIdsToDisplay(FovListWithSearchLicense.filter((fov) => (fov.tagids || []).filter((item) => selectedFloors.includes(item)).length > 0));
      }
    }
  }, [selectedAreas]);

  useEffect(() => {
    const fovcameraId = fovListIdsToDisplay.map((fov) => fov.parentdeviceid);
    const fovccdIds = deviceListItem.cameraList.filter((cam) => fovcameraId.includes(cam.id)).map((cam) => cam.parentdeviceid);
    const result = fovListIdsToDisplay.reduce((x, y) => {
      (x[y.siteids[0]] = x[y.siteids[0]] || []).push(y);
      return x;
    }, {});

    setSelectedWhereOptions((prev) => ({
      ...prev,
      areas: selectedAreas,
      floors: selectedFloors,
      sites: selectedSites,
      fovIds: [...new Set(fovListIdsToDisplay.map((fov) => fov.id))],
      ccdIds: [...new Set(fovccdIds)],
      targets: getTargetItems(fovListIdsToDisplay)
    }));

    setFovListIdsToDisplayGroupBySites(result);
  }, [fovListIdsToDisplay]);

  const getTargetItems = (fovListIdsToDisplay) => {
    let coreCCDId = "";
    let ccdRefId = "";
    const targetItems = fovListIdsToDisplay.map((fov) => {
      coreCCDId = deviceListItem.cameraList.find((cam) => cam.id === fov.parentdeviceid)?.parentdeviceid;
      ccdRefId = deviceListItem.companionDeviceList.find((ccd) => ccd.id === coreCCDId);
      return {
        id: fov.id,
        cameraid: fov.parentdeviceid,
        ccdid: coreCCDId,
        ccdqrcode: ccdRefId?.[ccdRefId.refidtype]
      };
    });

    const targetResult = targetItems.reduce((x, y) => {
      (x[y.ccdid] = x[y.ccdid] || []).push(y);
      return x;
    }, {});

    let itemTargets = [];
    Object.keys(targetResult).forEach((key) => {
      itemTargets.push({
        ccdid: key,
        ccdqrcode: targetResult[key][0]?.ccdqrcode,
        fovIds: targetResult[key].map((item) => item.id)
      });
    });
    return itemTargets;
  };

  const onSiteSelect = (e) => {
    setSelectedSites([e.target.value]);
    setSelectedFloors([]);
    setSelectedAreas([]);
  };

  const onFloorSelect = (e, floorId) => {
    setSelectedFloors((prevSelectedFloors) => {
      if (prevSelectedFloors.length > 0 && prevSelectedFloors.includes(floorId)) {
         let arealist = siteReducerSites.areas.filter((f) => f?.tagids?.[0] === floorId).map((a) => a.id);
         let s_selectedArrea = selectedAreas;
         arealist.forEach(areaId => {
          if(s_selectedArrea.includes(areaId)){
            s_selectedArrea = s_selectedArrea.filter((id) => id !== areaId);
          }
         });
         console.log(s_selectedArrea);
         setSelectedAreas(s_selectedArrea);
        return prevSelectedFloors.filter((id) => id !== floorId);
      } else {
        return [...prevSelectedFloors, floorId];
      }
    });
  };

  const onAreaSelect = (e, areaId) => {
    setSelectedAreas((prevSelectedAreas) => {
      if (prevSelectedAreas.length > 0 && prevSelectedAreas.includes(areaId)) {
        return prevSelectedAreas.filter((id) => id !== areaId);
      } else {
        return [...prevSelectedAreas, areaId];
      }
    });
  };

  const getSiteNameFromFloorId = (floorId) => {
    const floor = siteReducerSites.floors.find((f) => f.id === floorId);
    if (floor) {
      const siteId = floor.tagids?.[0];
      const site = siteReducerSites.sites.find((s) => s.id === siteId);
      return site ? site.name : "Unknown Site";
    }
    return "Unknown Site";
  };

  const changeCompanion = (e) => {
    // const selectedCompanion = deviceListItem.companionDeviceList.find(
    //   (item) => item.id === e.target.value
    // );
    // setSelectedWhereOptions((prev) => ({
    //   ...prev,
    //   companionDevice: selectedCompanion,
    // }));

    const selectedCmpanion = companionList.find((item) => item.id === e.target.value);
  };

  const companionDevice = selectedWhereOptions?.companionDevice;

  return (
    <>
      <div className="whereContainerDiv">
        <h2 className="search-where-title">Where do you want to search?</h2>
        <div className="row-flex">
          <div className="column-flex">
            <p className="search-where-label-bold">Site</p>
            <div className="input-group-vertical-gap-6">
              <RadioButtonGroup
                onChange={(e) => {
                  onSiteSelect(e);
                }}
                error={false}
                data={
                  siteListWithSearchFovs.length > 0 &&
                  siteListWithSearchFovs.map((siteId) => {
                    return {
                      name: siteReducerSites.sites.find((f) => f.id === siteId)?.name,
                      children: siteReducerSites.sites.find((f) => f.id === siteId)?.name,
                      value: siteId,
                      ariaLabel: "radio one",
                      disabled: false
                    };
                  })
                }
              />
            </div>
          </div>
          <div className="column-flex">
            <p className="search-where-label-bold">Floor:</p>
            {Object.keys(floorListWithSelectedSites).length === 0 && <p>{HISTORICALSEARCH_STATICS.NO_FLOORS_FOR_NONSELECTED_SITES_MESSAGE}</p>}
            {Object.keys(floorListWithSelectedSites).map((keyitem) => (
              <React.Fragment key={keyitem}>
                <div className="input-group-vertical-gap-6">
                  {Object.keys(floorListWithSelectedSites).length > 0 &&
                    floorListWithSelectedSites[keyitem].map((floor) => (
                      <div key={floor.id}>
                        <Checkbox
                          key={floor.id}
                          selected={selectedFloors.includes(floor.id)}
                          onChange={(e) => onFloorSelect(e, floor.id)}
                          label={<span className="labelStyle">{floor.name}</span>}
                        />
                      </div>
                    ))}
                </div>
              </React.Fragment>
            ))}
          </div>
          <div className="column-flex">
            <p className="search-where-label-bold">Area</p>
            {Object.keys(areaListWithSelectedFloors).length === 0 && <p>{HISTORICALSEARCH_STATICS.NO_AREAS_FOR_NONSELECTED_FLOORS_MESSAGE}</p>}
            {Object.keys(areaListWithSelectedFloors).map((keyitem) => (
              <React.Fragment key={keyitem}>
                <p className="search-where-area-label">{siteReducerSites.floors.find((f) => f.id === keyitem).name}</p>
                <div className="input-group-vertical-gap-6" style={{maxHeight: "200px", overflowY: "auto"}}>
                  {Object.keys(areaListWithSelectedFloors).length > 0 &&
                    areaListWithSelectedFloors[keyitem].map((area) => (
                      <div key={area.id}>
                        <Checkbox
                          key={area.id}
                          selected={selectedAreas?.includes(area.id)}
                          onChange={(e) => onAreaSelect(e, area.id)}
                          label={<span className="labelStyle">{area.name}</span>}
                        />
                      </div>
                    ))}
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
        <div>
          {/* <DropdownSelect label="Companion device" required={true} inlineLabel={false} onChange={changeCompanion} width="30%">
            {companionList &&
              companionList.map((item) => (
                <option selected={item?.id === companionDevice?.id} key={item?.id} value={item?.id}>
                  {item?.name}
                </option>
              ))}
          </DropdownSelect> */}
        </div>
      </div>
    </>
  );
};

export default Search_Where;
